import PropTypes from 'prop-types';
import React from 'react';

import VideoIllustration from '@wetransfer/transfer/component/illustration/video-illustration';
import I18n from '@wetransfer/transfer/modules/i18n/index';

const MarketingEmailPrompt = ({ subscribe, skip }) => {
  function handleClick() {
    subscribe(true);
  }

  return (
    <div className="transfer__window marketing-email-prompt">
      <div className="transfer__contents marketing-email-prompt__contents">
        <VideoIllustration
          type="transfer-complete-upload"
          src="transfer_window/transfer_completed-1"
          className="marketing-email-prompt__image "
        />
        <h2 className="marketing-email-prompt__title">
          {I18n.t('transfer.marketing-email-prompt.title')}
        </h2>
        <p className="marketing-email-prompt__text">
          {I18n.t('transfer.marketing-email-prompt.body')}
        </p>
      </div>
      <div className="transfer__footer marketing-email-prompt__footer">
        <button className="transfer__button " onClick={handleClick}>
          {I18n.t('transfer.marketing-email-prompt.subscribe')}
        </button>
        <button
          className="transfer__button transfer__button--alt"
          onClick={skip}
        >
          {I18n.t('transfer.marketing-email-prompt.skip')}
        </button>
      </div>
    </div>
  );
};

MarketingEmailPrompt.propTypes = {
  subscribe: PropTypes.func.isRequired,
  skip: PropTypes.func.isRequired,
};

export default MarketingEmailPrompt;
